import {Tooltip} from "react-tooltip";
import {useTranslation} from "react-i18next";
import SvgIcon from "../../components/svg-icon";

const GameFrameButtons = props => {

    const {t} = useTranslation()
    const {onClick} = props



    return (
        <div className="frame__cellar">
            <div className="frame__actions">
                <Tooltip className="tooltip-me" id="rank-tooltip"/>

                <button
                    data-tooltip-id="rank-tooltip"
                    data-tooltip-content={t('game.toggle-fullscreen')}
                    data-tooltip-place="bottom"
                    type="button" onClick={e => onClick('fullscreen')}>
                    <SvgIcon id={'expand'}/>

                </button>


                <Tooltip className="tooltip-me" id="landscape-tooltip"/>

                <button
                    className="frame-theatre"
                    data-tooltip-id="rank-tooltip"
                    data-tooltip-content={t('game.toggle-landscape')}
                    data-tooltip-place="bottom"
                    type="button">
                    <SvgIcon id={'wide'}/>
                </button>

            </div>

            <div className="frame__logo"/>

        </div>

    )

}

export default GameFrameButtons
